// manageThemisRules.ts
import axios, { AxiosResponse } from "axios";
import { ThemisRuleListItem } from "./ThemisRuleList";

type IdResponseDTO = { id: number };

export type CreateThemisRuleRequestDto = {
  name: string;
  description: string;
  targetScopeKey: string;
  phase: string;
  priority: number;
  isEnabled?: boolean;
  stopProcessing?: boolean;
};

export type UpdateThemisRuleRequestDto = {
  name: string;
  description: string;
  priority: number;
  isEnabled: boolean;
  stopProcessing: boolean;
};

export type ThemisRuleDto = {
  id: number;
  name: string;
  description?: string | null;
  targetScopeKey: string;
  phase: string;
  priority: number;
  isEnabled: boolean;
  stopProcessing: boolean;
  conditionGroups: any[];
  effects: any[];
};

export type ReorderThemisRulesRequestDto = {
  phase: string;
  orderedRuleIds: number[];
};

const baseURL = process.env.REACT_APP_API_URL;

if (!baseURL) {
  // eslint-disable-next-line no-console
  console.error(
    "[manageThemisRules] REACT_APP_API_URL is not set. Requests will fail."
  );
}

const themisAdminBase = `${baseURL}/admin/themis`;

export function getThemisRulesByPhase(
  phase: string
): Promise<AxiosResponse<ThemisRuleListItem[]>> {
  return axios.get(`${themisAdminBase}/rules/by-phase`, { params: { phase } });
}

export function getThemisRule(
  id: number
): Promise<AxiosResponse<ThemisRuleDto>> {
  return axios.get(`${themisAdminBase}/rules/${id}`);
}

export function createThemisRule(
  req: CreateThemisRuleRequestDto
): Promise<AxiosResponse<IdResponseDTO>> {
  return axios.post(`${themisAdminBase}/rules`, req);
}

export function updateThemisRule(
  id: number,
  req: UpdateThemisRuleRequestDto
): Promise<AxiosResponse<void>> {
  return axios.put(`${themisAdminBase}/rules/${id}`, req);
}

export function deleteThemisRule(id: number): Promise<AxiosResponse<void>> {
  return axios.delete(`${themisAdminBase}/rules/${id}`);
}

export function reorderThemisRulesByPhase(
  phase: string,
  orderedRuleIds: number[]
): Promise<AxiosResponse<void>> {
  const payload: ReorderThemisRulesRequestDto = { phase, orderedRuleIds };
  return axios.put(`${themisAdminBase}/rules/reorder-by-phase`, payload);
}
